import {withKnownRoute} from '../../lib/routes';
import {SheetsPage} from './sheets-page';

export default withKnownRoute(SheetsPage);
